import cx from 'clsx';
import * as React from 'react';

import useJackpotIncrement from '@/hooks/useJackpotIncrement';
import { JackpotType } from '@/types/gameTypes';
import {
  formatNumberToCurrency,
  isPrefixCurrencySymbol,
  mapCurrencyToSymbol,
} from '@/utils/currency';

import styles from './JackpotLayer.module.scss';

type JackpotLayerProps = { componentType: 'search' | 'gameTile' } & JackpotType;

const GT_JACKPOT = 'gt-jackpot';

const JackpotLayer = ({
  value,
  currencyCode,
  increaseVelocity,
  timestamp,
  updateInterval,
  componentType,
}: JackpotLayerProps) => {
  const jackpotValue = useJackpotIncrement(
    value,
    timestamp,
    increaseVelocity,
    updateInterval
  );
  const currencySymbol = mapCurrencyToSymbol(currencyCode);
  const isPrefix = isPrefixCurrencySymbol(currencyCode);
  const formattedJackpotValue = formatNumberToCurrency(
    jackpotValue,
    currencyCode,
    false
  );
  const splitedValue = formattedJackpotValue.split('.');
  const integerPart =
    `${splitedValue.slice(0, -1).join('.')}.` || formattedJackpotValue;
  const decimalPart =
    splitedValue.length > 1 ? splitedValue[splitedValue.length - 1] : '';

  return (
    <>
      <span
        className={cx(
          styles.integerPart,
          componentType === 'search'
            ? styles.integerPartSearch
            : styles.integerPartGameTile
        )}
        data-testid={`${GT_JACKPOT}_integer-value`}
      >
        {isPrefix && (
          <span className={styles.currencySymbol}>{currencySymbol}</span>
        )}
        {integerPart}
      </span>
      {decimalPart && (
        <span
          className={cx(
            styles.decimalPart,
            componentType === 'search'
              ? styles.decimalPartSearch
              : styles.decimalPartGameTile
          )}
          data-testid={`${GT_JACKPOT}_decimal-value`}
        >
          {decimalPart}
          {!isPrefix && (
            <span className={styles.currencySymbol}>
              {` ${currencySymbol}`}
            </span>
          )}
        </span>
      )}
    </>
  );
};

export default JackpotLayer;
